export const formatDate = (dateString) => {
  const date = new Date(dateString);

  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-GB", options).replace(/(am|pm)/i, (match) => match.toUpperCase());
};

export const formatInfoData = (data) => {
  let newData = {};

  return {
    ...newData,
    diamond: `${data?.totalDiaWeight?.toFixed(2)} Ct / ${data?.totalDiaPcs} Pcs`,
    goldbar: `${data?.totalGoldWeight?.toFixed(2)} g / ${data?.totalGoldGrossWeight?.toFixed(2)} g`,

    "Created By": `${data?.userRef?.firstName} ${data?.userRef?.lastName}`,
    "Created Time": formatDate(data?.createdAt),
    "Modified By": `${data?.modifiedBy?.firstName || "--"} ${data?.modifiedBy?.lastName || "--"}`,
    "Modified Time": `${data?.modifiedBy?.firstName ? formatDate(data?.updatedAt) : "--"}`,
  };
};
